import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";

// import  "./orderOnline.css"

function SectionFiveThemeFive() {
  const state: any = useSelector((state) => state);

  const jsonData: any = useSelector<any>((state) => state.homeJsonList);

  useEffect(() => {
  }, [jsonData]);
  return (
    <div className="wash-fold-section wash-fold-v2">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 d-none d-md-block">
            <div
              className="wash-fold-image"
              style={{
                backgroundImage: `url(${jsonData?.theme_5?.home?.section_5?.banner})`,
              }}
              role="img"
              aria-label="Wash and fold service"
            />
          </div>
          <div className="col-lg-7">
            <div className="wash-fold-card">
              <div className="wash-fold-text">
                <h2
                  style={{
                    color: `#${jsonData?.theme_5?.home?.section_5?.h2color}`,
                  }}
                >
                  {jsonData?.theme_5?.home?.section_5?.title}
                </h2>
              </div>
              <div className="wash-fold-info">
                <ul>
                  {jsonData?.theme_5?.home?.section_5?.wash_title?.map(
                    (item: any) => {
                      return (
                        <li>
                          <i className="fa fa-check"></i>{" "}
                          <p
                            style={{
                              color: `#${jsonData?.theme_5?.home?.section_5?.paracolor}`,
                            }}
                          >
                            {item?.wash_list}
                          </p>
                        </li>
                      );
                    }
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionFiveThemeFive;
